module.exports = "<div class=\"container\" style=\"margin:40px auto;\">\r\n\t<article class=\"indutry\" *ngFor=\"let industry of industries\">\r\n\t\t<img src=\"/assets/images/{{industry.url}}\" title=\"{{industry.title}}\">\r\n\t\t<h4>{{industry.name}}</h4>\r\n\t</article>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/industries/industries.tpl.html
// module id = 188
// module chunks = 1